import { InformationCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Button, ButtonSize, ButtonVariant, Modal } from "shared/components";

interface DisconnectMetaAdsModalProps {
  opened: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DisconnectMetaAdsModal = ({
  opened,
  loading,
  onClose,
  onConfirm
}: DisconnectMetaAdsModalProps) => (
  <Modal
    opened={opened}
    onClose={onClose}
    panelClassName="p-6 max-w-[366px] w-full"
  >
    <div className="grid place-items-center pb-6">
      <div className="grid w-16 h-16 place-items-center rounded-full bg-danger-50">
        <HugeiconsIcon
          icon={InformationCircleIcon}
          className="text-danger-500"
          size={32}
        />
      </div>
    </div>

    <h1 className="text-center text-xl font-bold text-content-1000 mb-2">
      Disconnect Meta Lead Ads?
    </h1>
    <p className="text-center text-sm text-content-400 font-medium mb-6">
      New leads from your Facebook Lead Ads campaigns will stop arriving in
      BoomCRM, and connection stats will be cleared. Leads already imported are
      not affected. You can reconnect at any time.
    </p>

    <div className="flex gap-2">
      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.BASE}
        className="w-full"
        onClick={onClose}
        disabled={loading}
      >
        Cancel
      </Button>
      <Button
        variant={ButtonVariant.DANGER}
        size={ButtonSize.BASE}
        className="w-full"
        onClick={onConfirm}
        loading={loading}
        disabled={loading}
      >
        Disconnect
      </Button>
    </div>
  </Modal>
);
